import { List } from 'antd';
import { useTheme } from 'styled-components';
import useTestInformationPageController from '../../1_application/test/testInformationPageController';
import ITestRepository from '../../2_domain/test/iTestRepository';
import { TestCategory, TestItemSummary } from '../../2_domain/test/test';
import withAsync from '../../lib/asyncBounrdary/withAsync';
import wrapPromise from '../../lib/asyncBounrdary/wrapPromise';
import Get from '../../lib/di/get';
import { getIndex } from '../../lib/util/pagination';
import { SearchControlBoxContainer } from '../core/components/box/boxContainer';
import Column from '../core/components/box/column';
import FlexBox from '../core/components/box/flexBox';
import Row from '../core/components/box/row';
import SizedBox from '../core/components/box/sizedBox';
import LXLowButton from '../core/components/buttons/lxLowButton';
import LXPageSizeSelector from '../core/components/buttons/lxPageSizeSelector';
import LXRefreshButton from '../core/components/buttons/lxRefreshButton';
import LXTestCategorySelector from '../core/components/buttons/lxTestCategorySelector';
import { XCenter } from '../core/components/center';
import LXList from '../core/components/list/lx_list';
import {
  HeaderPadding,
  ItemPadding,
} from '../core/components/list/lx_list_padding';
import LXError from '../core/error/lx_error';
import LXPagination from '../core/pagination/lxPagination';
import LXSpinner from '../core/spinner/lx_spinner';
import LXSearcher from '../core/texts/lxSearcher';
import { LXbody, LXCaption, LXh2 } from '../core/texts/lxText';

interface TestInformationPageProps {}
const TestInformationPage = (
  props: TestInformationPageProps & { testCategories: TestCategory[] }
) => {
  const theme = useTheme();
  const c = useTestInformationPageController();
  const pagination = (
    <Row justifyContent="space-between" alignItems="center">
      <SizedBox width={198}></SizedBox>
      <LXPagination
        current={c.pageResult.pageNumber}
        pageSize={c.pagination.pageSize}
        total={c.testItems.length}
        onChange={c.setPageNumber}
      ></LXPagination>
      <Row alignItems="center" alignSelf="flex-end">
        <LXbody color={theme.colors.caption}>{theme.texts.rowsPerPage}</LXbody>
        <SizedBox width={10}></SizedBox>
        <LXPageSizeSelector
          value={c.pagination.pageSize}
          onSelect={c.setPageSize}
        ></LXPageSizeSelector>
      </Row>
    </Row>
  );
  const listHeader = (
    <HeaderPadding>
      <Row alignItems="center">
        <LXCaption flexShrink={0} width={'40px'}>
          {theme.test.no}
        </LXCaption>
        <SizedBox width={16}></SizedBox>
        {/* <LXCaption flexShrink={0} width={'70px'}>
          {theme.test.testCode}
        </LXCaption>
        <SizedBox width={16}></SizedBox> */}
        <LXCaption flexShrink={0} width={'240px'}>
          {theme.test.testName}
        </LXCaption>
        <SizedBox width={16}></SizedBox>
        <LXCaption flexShrink={0} width={'100px'}>
          {theme.test.specimen}
        </LXCaption>
        <SizedBox width={16}></SizedBox>
        <LXCaption flexShrink={0} width={'160px'}>
          {theme.test.method}
        </LXCaption>
        <SizedBox width={16}></SizedBox>
        <LXCaption flexShrink={0} width={'160px'}>
          {theme.test.volume}
        </LXCaption>
        <SizedBox width={16}></SizedBox>
        <LXCaption flexShrink={0} width={'130px'}>
          {theme.test.reported}
        </LXCaption>
      </Row>
    </HeaderPadding>
  );

  const listItemBuilder = (test: TestItemSummary, idx: number) => (
    <List.Item onClick={c.navigateToTestItemDetail(test)}>
      <ItemPadding>
        <Row alignItems="center">
          <LXbody width={'40px'}>
            {getIndex(c.pagination.pageNumber, c.pagination.pageSize, idx)}
          </LXbody>
          <SizedBox width={16}></SizedBox>
          {/* <LXbody width={'70px'}>{test.serial}</LXbody>
          <SizedBox width={16}></SizedBox> */}
          <LXbody width={'240px'}>{test.name}</LXbody>
          <SizedBox width={16}></SizedBox>
          <LXbody width={'100px'}>{test.specimen}</LXbody>
          <SizedBox width={16}></SizedBox>
          <LXbody width={'160px'}>{test.testCategory.label ?? '-'}</LXbody>
          <SizedBox width={16}></SizedBox>
          <LXbody width={'160px'}>{test.sampleCollectingFigure ?? '-'}</LXbody>
          <SizedBox width={16}></SizedBox>
          <LXbody width={'130px'}>{`${test.requiredDays} Days`}</LXbody>
          {/* <LXbody width={'130px'}>{`${test.requiredDays} ${
            test.requiredDays === 1 ? theme.texts.day : '-'
          }`}</LXbody> */}
        </Row>
      </ItemPadding>
    </List.Item>
  );

  const serachBox = (
    <SearchControlBoxContainer width="none">
      <Row width="960px" padding="0 30px">
        <LXSearcher
          value={c.searchText}
          onChange={c.setSearchText}
          width={320}
          placeholder={theme.texts.keywordSearch}
        ></LXSearcher>
        <SizedBox width={16}></SizedBox>
        <LXTestCategorySelector
          placeholder={theme.test.category}
          testCategories={props.testCategories}
          width={240}
          value={c.selectedCategory}
          onSelect={c.setSelectedCategory}
        ></LXTestCategorySelector>
        <FlexBox flexBasis="163px"></FlexBox>
        <LXLowButton onClick={c.onClickSearchHandler}>
          {theme.texts.search}
        </LXLowButton>
        <SizedBox width={8}></SizedBox>
        <LXRefreshButton onClick={c.onReset}></LXRefreshButton>
      </Row>
    </SearchControlBoxContainer>
  );

  const header = (
    <Row>
      <LXh2>{theme.texts.testItem}</LXh2>
      <SizedBox width={8}></SizedBox>
      <LXh2 fontWeight={400} color={theme.colors.caption}>
        {c.testItems.length}
      </LXh2>
    </Row>
  );
  return (
    <XCenter>
      <Column>
        <SizedBox height={80} />
        {header}
        <SizedBox height={40} />
        {serachBox}
        <SizedBox height={40} />
        <LXList<TestItemSummary>
          datas={c.testItems.slice(
            c.pagination.pageSize * c.pagination.pageNumber,
            c.pagination.pageSize * (c.pagination.pageNumber + 1)
          )}
          header={listHeader}
          itemBuilder={listItemBuilder}
          loading={c.isLoading}
        ></LXList>
        <SizedBox height={16} />
        {pagination}
      </Column>
    </XCenter>
  );
};

const TestInformationPageWrapper = (props: TestInformationPageProps) => {
  const testRepo = Get.find<ITestRepository>('ITestRepository');
  const testCategories = wrapPromise<void, TestCategory[]>(
    testRepo.getTestCategories,
    undefined,
    'testRepoKey'
  )();
  return (
    <TestInformationPage
      {...props}
      testCategories={testCategories}
    ></TestInformationPage>
  );
};

export default withAsync({
  child: TestInformationPageWrapper,
  suspenseFallback: <LXSpinner></LXSpinner>,
  errorFallback: <LXError></LXError>,
});
